/**
 * @auth 赖传峰
 * @date 2023/2/1
 */
import { RouteQueryKeyActionValue } from '@/types/enum'
import { computed } from 'vue'
import { type RouteLocationNormalized, useRoute } from 'vue-router'

export const getKeyFromQuery = <T extends string>(key: 'action' | 'file_ids', route: RouteLocationNormalized) => {
  const action = route.query[key] as undefined | T | T[]
  if (!action) return []

  return Array.isArray(action) ? action : [action]
}

export default () => {
  const route = useRoute()
  return computed(() => getKeyFromQuery<RouteQueryKeyActionValue>('action', route))
}
